import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CoachingCallInsight } from '../../features/coaching/coachingCallInsight/CoachingCallInsight';
import { selectCurrentUser, selectCurrentUserManagerLevel, selectCurrentUserParentClient } from '../login/authSlice';
import { CoachingInsightFeedback } from '../../components/coachingInsight/coachingInsightFeedback/CoachingInsightFeedback';
import { ROLES } from '../../constants';

export const CallInsight = () => {
    const currentUserParentClient = useSelector(selectCurrentUserParentClient);
    const loggedUser = useSelector(selectCurrentUser);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);

    useEffect(() => {
        localStorage.removeItem('insightsSelectedManager');
        localStorage.removeItem('insightsSelectedTL');
        localStorage.removeItem('insightsSelectedDateRange');
        localStorage.removeItem('insightsSelectedTeam');
    }, []);

    return (
        <div>
            <div className="card shadow bg-body rounded mt-3 border-0">
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-4 text-start">
                            <span id="label_employeename" className="mt-1 ms-3 d-inline-block">
                                {`Hello ${loggedUser}!`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            {
                                <TabView
                                    activeIndex={activeTabIndex}
                                    onTabChange={(e) => {
                                        setActiveTabIndex(e.index);
                                    }}
                                >
                                    <TabPanel header="Call Summary">

                                        <CoachingCallInsight userParentClient={currentUserParentClient} />
                                    </TabPanel>
                                    <TabPanel header="Call Detail">
                                        <CoachingCallInsight userParentClient={currentUserParentClient} fromTab='callDetails' />
                                    </TabPanel>
                                    {!ROLES.Agents.includes(userManagerLevel) &&
                                        <TabPanel header="Insight Feedback">
                                            <CoachingInsightFeedback />
                                        </TabPanel>
                                    }
                                </TabView>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
